import IBaseShiftEntity from "./IBaseShiftEntity";

/**
 * Interface to represent a Smart Schedule Shift Entity
 */
export enum WeekDays {
    Monday = "Monday",
    Tuesday = "Tuesday",
    Wednesday = "Wednesday",
    Thursday = "Thursday",
    Friday = "Friday",
    Saturday = "Saturday",
    Sunday = "Sunday"
}

export default interface ISmartScheduleShiftEntity extends IBaseShiftEntity {
    openSlots: number;
    repeatOn: WeekDays[];
}
